export const AVAILABLE_NARRATORS = [
    {
        id: 'default',
        label: 'Standard (City Drift Companion)',
        description: 'Neutraler, ortssensibler Companion in dritter Person',
    },
    {
        id: 'tschauko',
        label: 'Dr. Peter Tschauko (Ich-Form)',
        description: 'Historischer Avatar — Naturforscher 1852-1904, spricht in Ich-Form als wäre er anwesend',
    },
];
const STORAGE_KEY = 'gps-tracker-narrator';
const DEFAULT_NARRATOR = 'default';
export class NarratorState {
    constructor(_bus) {
        this._bus = _bus;
        this._current = this._resolveInitial();
    }
    /** Currently active narrator id (e.g. 'default', 'tschauko'). */
    get current() {
        return this._current;
    }
    /** Set the narrator. Pass null/empty to reset to default. */
    setById(id) {
        const next = (id || DEFAULT_NARRATOR).trim() || DEFAULT_NARRATOR;
        if (next === this._current)
            return;
        this._current = next;
        this._persist();
        this._bus.emit('narrator:changed', { name: this._current });
    }
    /** Known narrators — useful for view rendering. */
    get available() {
        return AVAILABLE_NARRATORS;
    }
    /**
     * URL param > localStorage > default. URL param is sticky for the
     * session AND written to localStorage so a refresh keeps the choice
     * even if the URL param is dropped.
     */
    _resolveInitial() {
        try {
            const fromUrl = new URLSearchParams(window.location.search).get('narrator');
            if (fromUrl && fromUrl.trim()) {
                const v = fromUrl.trim();
                window.localStorage.setItem(STORAGE_KEY, v);
                return v;
            }
            const fromStorage = window.localStorage.getItem(STORAGE_KEY);
            if (fromStorage && fromStorage.trim())
                return fromStorage.trim();
        }
        catch {
            // localStorage may be blocked (private mode); fall through to default
        }
        return DEFAULT_NARRATOR;
    }
    _persist() {
        try {
            window.localStorage.setItem(STORAGE_KEY, this._current);
        }
        catch {
            // localStorage may be blocked; selection becomes session-only
        }
    }
}
//# sourceMappingURL=NarratorState.js.map